module.exports = __webpack_public_path__ + "static/media/login-via-sms-otp-logo.6dc1c4ee.png";